class AvatarAPIService {
  constructor() {
    if (new.target === AvatarAPIService) {
      throw new Error("Cannot instantiage and abstract class.");
    }

    if (this.getAvatarDetails === AvatarAPIService.prototype.getAvatarDetails) {
      throw new Error(
        "Class extending AvatarAPIService must override 'getAvatarDetails({ key, value })'."
      );
    }
  }

  async getAvatarDetails({ key, value }) {
    throw new Error(
      "Method 'getAvatarDetails({ key, value })' must be implemented."
    );
  }
}

export default AvatarAPIService;
